export function createPermisstionCheckGuard(router) {
  router.beforeEach(async (to, from, next) => {
    next();
    return true;
  });
}